module.exports = __webpack_public_path__ + "img/icon_num_nz.772c8570.png";